// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"18746320","154":"5ade2d58","533":"e74b445f"}[chunkId] + ".chunk.css";
};